<template>
  <el-dialog
    title="选择优惠群"
    :visible.sync="showDialog"
    :before-close="cancelAction"
    width="1025px"
    append-to-body
  >
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">券名</span>
        <el-input
          v-model="params.title"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">券类型</span>
        <el-select
          v-model="params.card_type"
          class="select"
          placeholder="请选择"
        >
          <el-option
            label="代金券"
            value="cash"
          />
          <el-option
            label="折扣券"
            value="discount"
          />
          <el-option
            label="兑换券"
            value="gift"
          />
        </el-select>
      </li>
      <li>
        <span class="m-r-6">渠道</span>
        <el-select
          v-model="params.channel"
          class="select"
          placeholder="请选择"
        >
          <el-option
            label="全渠道"
            value="all"
          />
          <el-option
            label="微信"
            value="wechat"
          />
          <el-option
            label="支付宝"
            value="alipay"
          />
        </el-select>
      </li>
      <li>
        <span class="m-r-6">券渠道</span>
        <el-select
          v-model="params.card_source"
          class="select"
          placeholder="请选择"
        >
          <el-option
            label="本地"
            value="local"
          />
          <el-option
            label="TOPI"
            value="topi"
          />
          <el-option
            label="直播间"
            value="zhibo"
          />
          <el-option
            label="草动"
            value="caodong"
          />
          <el-option
            label="商家券"
            value="merch"
          />
        </el-select>
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="listData"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      @select="handleSelectionChange"
      @select-all="selectAll"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="50"
      />
      <el-table-column
        prop="title"
        width="200px"
        label="券名"
      />
      <el-table-column
        prop="card_type_val"
        label="券类型"
      />
      <el-table-column
        prop="channel_val"
        label="渠道"
      />
      <el-table-column
        prop="card_source_val"
        label="券渠道"
      />
      <el-table-column
        label="有效期"
        width="300px"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.takeEffect">{{ scope.row.takeEffect }}</span>
          <span v-else>{{ scope.row.begin_time }} - {{ scope.row.end_time }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.pageSize"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <span class="m-r-6">已选中{{ selectCount }}张券</span>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="saveAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getCouponList } from '@/api/component'
export default {
  props: {
    couponVisible: {
      // 展示模态框
      type: Boolean,
      default: false
    },
    selectData: {
      // 已勾选的列表数据
      type: Array,
      default: () => {
        return []
      }
    },
    chooseOne: {
      // 只可选择一个
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      key: 1,
      listData: [],
      total_count: 0,
      loading: false,
      params: {
        page: 1,
        pageSize: 10,
        title: '',
        card_type: '',
        channel: '',
        card_source: ''
      },
      multipleSelection: [],
      submitLoading: false,

      couponType: '',
      selectCount: 0,
      firstShow: false
    }
  },
  computed: {
    showDialog () {
      return this.couponVisible
    }
  },
  watch: {
    couponVisible (newVal, oldVal) {
      if (newVal) {
        this.firstShow = true
        this.selectCount = this.selectData ? this.selectData.length : 0
        this.getList()
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.card_id
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('closeCouponDialog')

      // 如果不需要默认勾选则关闭取消
      if (!this.selectData) {
        this.multipleSelection = []
        this.selectCount = 0
        this.$refs.multipleTable.clearSelection()
      }
    },
    async getList () {
      this.loading = true
      const data = await getCouponList(this.params)
      if (data) {
        this.listData = data.list
        this.total_count = data.total_count
        this.loading = false

        // 获取选中元素 可传数组对象，也可传数组id
        if (this.firstShow) {
          this.firstShow = false
          this.toggleSelection(this.selectData)
        }
      }
    },
    // 查询
    searchList () {
      this.params.page = 1
      this.getList()
    },
    // 全选事件
    selectAll (val) {
      this.multipleSelection = val
      this.selectCount = val.length
    },
    // table表格选择
    handleSelectionChange (selection, row) {
      if (this.chooseOne) {
        // 单选
        this.$refs.multipleTable.clearSelection()
        if (selection.length === 0) {
          return
        } else {
          this.multipleSelection = [row]
          this.selectCount = 1
          this.$refs.multipleTable.toggleRowSelection(row, true)
        }
      } else {
        this.multipleSelection = selection
        this.selectCount = selection.length
      }
    },
    saveAction () {
      // 保存选中的Ids
      let couponIds = []
      this.multipleSelection.forEach((v) => {
        couponIds = couponIds.concat(v.card_id)
      })
      this.$emit('chooseCoupon', this.multipleSelection, couponIds.join(','))
    },
    toggleSelection (rows) {
      if (rows && rows.length > 0) {
        rows.forEach((row) => {
          if (row.card_id) {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          } else {
            let newrow = { card_id: row }
            this.$refs.multipleTable.toggleRowSelection(newrow, true)
          }
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.select {
  width: 116px;
}
</style>
